export const TOAST_LIMIT = 1;
export const TOAST_REMOVE_DELAY = 5000;
